import { usePagedList } from "../../platform/async/usePagedList";
import { PagedBoard } from "../../platform/ui/PagedBoard";
import { PageShell } from "../../platform/ui/PageShell";
import { StateMessage } from "../../platform/ui/StateMessage";
import { UpdateItem } from "./UpdateItem";
import { fetchUpdates } from "./updates-api";
import "./updates.css";

export function UpdatesPage() {
  const updates = usePagedList(fetchUpdates);
  const fetching = updates.status === "loading_more";

  return (
    <PageShell
      eyebrow="Latest first"
      title="What I've Been Up To"
      lead="Short notes from me as things happen."
      layout="viewport"
    >
      {updates.items.length > 0 ? (
        <PagedBoard
          items={updates.items}
          getKey={(update) => update.id}
          renderItem={(update) => <UpdateItem update={update} />}
          canFetchMore={updates.nextCursor !== null && updates.status === "ready"}
          fetching={fetching}
          onFetchMore={updates.loadMore}
          label="Updates"
          newerLabel="Newer"
          olderLabel="Older"
          itemMinWidthRem={17}
          itemMinHeightRem={7.75}
          maxColumns={2}
        />
      ) : (
        <div className="updates-state" data-slot="stage">
          {updates.status === "loading" ? (
            <StateMessage tone="loading" title="Fetching updates" />
          ) : null}
          {updates.status === "failed" ? (
            <StateMessage
              tone="error"
              title="The updates could not be loaded"
              action={{ label: "Try again", onSelect: updates.reload }}
            >
              {updates.error?.message}
            </StateMessage>
          ) : null}
          {updates.status === "ready" ? (
            <StateMessage tone="empty" title="Nothing here yet">
              Orla has not posted an update yet.
            </StateMessage>
          ) : null}
        </div>
      )}
      {updates.status === "failed_more" ? (
        <StateMessage
          tone="error"
          title="Older updates could not be loaded"
          action={{ label: "Try again", onSelect: updates.loadMore }}
        >
          {updates.error?.message}
        </StateMessage>
      ) : null}
    </PageShell>
  );
}
